import React, { useState } from 'react';
import styles from '../casadebolosbarretos/casadebolosbarretos.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import BG1 from './src/bg-casadebolosbarretos-1.png';
import BG2 from './src/bg-casadebolosbarretos-2.png';
import BG3 from './src/bg-casadebolosbarretos-3.png';
import BG4 from './src/bg-casadebolosbarretos-4.png';
import InfoIcon from '../../icons/infoIcon.tsx';
import Modal from './modal.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Casadebolosbarretos: React.FC = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        title: '',
        address: '',
        whatsappLink: '',
        mapsLink: ''
    });

    const openModal = (title: string, address: string, whatsapp: string, maps: string) => {
        setModalData({
            title,
            address,
            whatsappLink: whatsapp,
            mapsLink: maps
        });
        setModalOpen(true);
    };

    const closeModal = () => setModalOpen(false);

    return (
        <div className={styles.casadebolosbarretos}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}>
                    <div className={styles["carousel-track"]}>
                        <img src={BG1} alt="Imagem 1" />
                        <img src={BG2} alt="Imagem 2" />
                        <img src={BG3} alt="Imagem 3" />
                        <img src={BG4} alt="Imagem 4" />
                        <img src={BG1} alt="Imagem 1" />
                        <img src={BG2} alt="Imagem 2" />
                        <img src={BG3} alt="Imagem 3" />
                        <img src={BG4} alt="Imagem 4" />
                    </div>
                </div>
                <div className={styles["container-thunder"]}>
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile"
                    />
                    <h1>CASA DE BOLOS BARRETOS</h1>
                    <p className="mb-4">Garanta o seu em uma das nossas 3 lojas:</p>

                    <div className={styles.links}>
                        <Link
                            href="https://www.casadebolos.com.br/nossos-bolos/"
                            title="Catálogo"
                            icon={<CatalogIcon color="#B14C38" height="40" />}
                            backgroundColor="#F5C5B1"
                            backgroundColorHover="#F3B197"
                            colorText="#B14C38"
                        />
                        <div onClick={() => openModal(
                            'Loja - Centro',
                            'Rua 20, nº 600 – Esquina da 23',
                            'https://wa.me/551733245395?text=Olá, gostaria de mais informações...',
                            'https://maps.app.goo.gl/j3yL8VN4xgUtwsMy9'
                        )}>
                            <Link
                                href="#"
                                title="Loja - Centro"
                                icon={<InfoIcon color="#B14C38" height="32" />}
                                backgroundColor="#F5C5B1"
                                backgroundColorHover="#F3B197"
                                colorText="#B14C38"
                                onlyShow={true}
                            />
                        </div>
                        <div onClick={() => openModal(
                            'Loja - Baroni',
                            'Rua 32, nº 300 – Esquina da 39',
                            'https://wa.me/551733225683?text=Olá, gostaria de mais informações...',
                            'https://maps.app.goo.gl/usRS8834qjKFRZjJ7'
                        )}>
                            <Link
                                href="#"
                                title="Loja - Baroni"
                                icon={<InfoIcon color="#B14C38" height="32" />}
                                backgroundColor="#F5C5B1"
                                backgroundColorHover="#F3B197"
                                colorText="#B14C38"
                                onlyShow={true}
                            />
                        </div>
                        <div onClick={() => openModal(
                            'Loja - Frade Monte',
                            'Av. Frade Monte, nº 831',
                            'https://wa.me/5517988198010?text=Olá, gostaria de mais informações...',
                            'https://maps.app.goo.gl/JchHoRZhHUbuMPH76'
                        )}>
                            <Link
                                href="#"
                                title="Loja - Frade Monte"
                                icon={<InfoIcon color="#B14C38" height="32" />}
                                backgroundColor="#F5C5B1"
                                backgroundColorHover="#F3B197"
                                colorText="#B14C38"
                                onlyShow={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={modalOpen}
                onClose={closeModal}
                title={modalData.title}
                address={modalData.address}
                whatsappLink={modalData.whatsappLink}
                mapsLink={modalData.mapsLink}
            />
        </div>
    );
};

export default Casadebolosbarretos;
